import { render, staticRenderFns } from "./Imprint.vue?vue&type=template&id=762fabaf&"
import script from "./Imprint.vue?vue&type=script&lang=ts&"
export * from "./Imprint.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports